import _extends from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import { noop } from 'lodash';
import React, { forwardRef, useEffect, useState } from 'react';
var cachedScripts = [];
function useScript(src) {
  // Keeping track of script loaded and error state
  var _useState = useState({
      loaded: false,
      error: false
    }),
    state = _useState[0],
    setState = _useState[1];
  useEffect(function () {
    // Calling without a src is effectively a noop so you can maintain hook rules
    if (!src) {
      setState({
        loaded: false,
        error: false
      });
      return noop;
    }

    // If cachedScripts array already includes src that means another instance
    // of this hook already loaded this script, so no need to load again.
    if (cachedScripts.includes(src)) {
      setState({
        loaded: true,
        error: false
      });
      return noop;
    }
    cachedScripts.push(src);

    // Create script
    var script = document.createElement('script');
    script.src = src;
    script.async = true;

    // Script event listener callbacks for load and error
    var onScriptLoad = function onScriptLoad() {
      setState({
        loaded: true,
        error: false
      });
    };
    var onScriptError = function onScriptError() {
      // Remove from cachedScripts we can try loading again
      var index = cachedScripts.indexOf(src);
      if (index >= 0) {
        cachedScripts.splice(index, 1);
      }
      script.remove();
      setState({
        loaded: true,
        error: true
      });
    };
    script.addEventListener('load', onScriptLoad);
    script.addEventListener('error', onScriptError);

    // Add script to document body
    document.body.appendChild(script);

    // Remove event listeners on cleanup
    return function () {
      script.removeEventListener('load', onScriptLoad);
      script.removeEventListener('error', onScriptError);
    };
  }, [src] // Only re-run effect if script src changes
  );
  return [state.loaded, state.error];
}
export default useScript;
export function withScript(Component, scriptSrc) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    var _useScript = useScript(scriptSrc),
      _useScript2 = _slicedToArray(_useScript, 2),
      scriptLoaded = _useScript2[0],
      scriptError = _useScript2[1];
    return __jsx(Component, _extends({}, props, {
      ref: ref,
      scriptError: scriptError,
      scriptLoading: !scriptLoaded
    }));
  });
}